import { useQuery } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useProjectsInfo = (currentPage, pageSize, searchValue) => {
  const data = useQuery(
    ["projectsAllInfoList", currentPage, pageSize, searchValue],
    () =>
      axiosClient.get(
        `/Project/GetProjectsAllInfoList?currentPage=${currentPage}&pageSize=${pageSize}&searchValue=${searchValue}`
      )
  );

  return { data };
};
export default useProjectsInfo;
